import IsendContactInformationService from "../../domain/services/IContactInformation.service";
import { sendContactInfo } from "./api/apiContactInfo";

export default class contactInfoUtilService implements IsendContactInformationService {
  async sendContactInformation(request: any): Promise<any> {
    return await sendContactInfo(request);
  }
}
